import { useState, useEffect, useCallback } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import { FaArrowRight, FaTags } from "react-icons/fa";
import "../../styles/admin-shared.css";
import "../Users/users-admin.css";
import FacilityTypeManagementModals from "./FacilityTypeManagementModals";

export default function FacilityTypeManagementPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [facilityTypes, setFacilityTypes] = useState([]);
    const [filteredTypes, setFilteredTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [flash, setFlash] = useState(null);

    const [modal, setModal] = useState(null);
    const [modalFacilityTypeId, setModalFacilityTypeId] = useState(null);

    const fetchFacilityTypes = useCallback(async () => {
        setIsLoading(true);
        try {
            const res = await backEnd_request.get("/FacilityTypes");
            const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
            setFacilityTypes(data);
            setFilteredTypes(data);
        } catch (error) {
            console.error("Fetch Error:", error);
            setFacilityTypes([]);
            setFilteredTypes([]);
        } finally {
            setIsLoading(false);
        }
    }, [backEnd_request]);

    useEffect(() => {
        fetchFacilityTypes();
    }, [fetchFacilityTypes]);

    useEffect(() => {
        if (location.state?.successMessage) {
            setFlash({ message: location.state.successMessage, variant: "success" });
            navigate(".", { replace: true, state: {} });
        }
    }, [location.state, navigate]);

    useEffect(() => {
        if (!flash?.message) return undefined;
        const t = setTimeout(() => setFlash(null), 4500);
        return () => clearTimeout(t);
    }, [flash]);

    const handleSearch = (term) => {
        setSearchTerm(term);
        if (!term.trim()) {
            setFilteredTypes(facilityTypes);
            return;
        }
        const filtered = facilityTypes.filter((type) => type.name?.toLowerCase().includes(term.toLowerCase()));
        setFilteredTypes(filtered);
    };

    const handleDelete = async (facilityTypeId) => {
        if (!window.confirm("هل أنت متأكد من حذف هذا النوع؟")) return;
        try {
            await backEnd_request.delete(`/FacilityTypes/${facilityTypeId}`);
            await fetchFacilityTypes();
            setFlash({ message: "تم حذف نوع الفعالية بنجاح.", variant: "success" });
        } catch (error) {
            console.log(error.response?.data || error);
            setFlash({
                message: error.response?.data?.message || "تعذر حذف النوع. حاول مرة أخرى.",
                variant: "danger",
            });
        }
    };

    const closeModal = () => {
        setModal(null);
        setModalFacilityTypeId(null);
    };

    const onModalSaved = ({ message, variant } = {}) => {
        fetchFacilityTypes();
        setFlash({
            message: message || "تم حفظ التغييرات بنجاح",
            variant: variant || "success",
        });
    };

    const openCreate = () => {
        setModal("create");
        setModalFacilityTypeId(null);
    };

    const openEdit = (id) => {
        setModal("edit");
        setModalFacilityTypeId(id);
    };

    return (
        <div className="users-page-minimal users-admin-page" style={{ direction: "rtl", fontFamily: "Cairo, sans-serif" }}>
            <div className="container pb-5 pt-4 px-3">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 pb-3 border-bottom gap-3">
                    <div>
                        <h3 className="fw-bold text-primary mb-1 d-flex align-items-center gap-2">
                            <span className="rounded-3 bg-primary bg-opacity-10 p-2 d-inline-flex text-primary">
                                <FaTags />
                            </span>
                            أنواع الفعالية
                        </h3>
                        <p className="text-muted small mb-0">تصنيف أنواع المنشآت المتاحة في النظام</p>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center px-4 rounded-pill shadow-sm"
                            onClick={openCreate}
                        >
                            <i className="bi bi-plus-lg ms-2" /> إضافة نوع
                        </button>
                        <button type="button" onClick={() => navigate(PATHS.ADMIN.HOME)} className="btn btn-outline-secondary rounded-pill">
                            <FaArrowRight className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                {flash?.message ? (
                    <div
                        className={`users-admin-alert px-3 py-2 mb-3 d-flex align-items-center justify-content-between gap-2 ${flash.variant === "danger" ? "users-admin-alert--danger" : ""}`}
                        role="alert"
                    >
                        <span>{flash.message}</span>
                        <button
                            type="button"
                            className={`btn btn-sm btn-link p-0 ${flash.variant === "danger" ? "text-danger" : "text-success"}`}
                            onClick={() => setFlash(null)}
                        >
                            إغلاق
                        </button>
                    </div>
                ) : null}

                <div className="users-toolbar mb-3">
                    <div className="users-count-chip">
                        إجمالي الأنواع
                        <span>{facilityTypes.length}</span>
                    </div>
                    <div className="users-search-wrap">
                        <div className="bg-white border rounded-4 p-2 shadow-sm">
                            <div className="input-group border-0">
                                <span className="input-group-text bg-transparent border-0 text-muted">
                                    <i className="bi bi-search" />
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-0 shadow-none py-2"
                                    placeholder="ابحث عن نوع فعالية..."
                                    value={searchTerm}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {isLoading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border spinner-border-sm text-secondary" />
                    </div>
                ) : (
                    <div className="users-table-shell facility-types-table-shell">
                        <div className="table-responsive">
                            <table className="table users-table align-middle mb-0 users-table--facility-types">
                                <thead>
                                    <tr>
                                        <th className="text-center col-index">#</th>
                                        <th className="text-end">اسم النوع</th>
                                        <th className="text-center">الإجراءات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTypes.length === 0 ? (
                                        <tr>
                                            <td colSpan={3}>
                                                <div className="empty-state">
                                                    <i className="bi bi-inbox fs-4 mb-2" />
                                                    <div>لا توجد أنواع مطابقة للبحث</div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredTypes.map((item, index) => (
                                            <tr key={item.facilityTypeId}>
                                                <td className="text-center col-index fw-semibold text-muted">{index + 1}</td>
                                                <td className="text-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-decoration-none user-name text-start"
                                                        onClick={() =>
                                                            navigate(
                                                                `/admin/establishments-list?facilityType=${encodeURIComponent(item.name)}`
                                                            )
                                                        }
                                                    >
                                                        {item.name}
                                                    </button>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex gap-2 justify-content-center flex-wrap">
                                                        <button
                                                            type="button"
                                                            className="btn-minimal"
                                                            title="عرض المنشآت"
                                                            onClick={() =>
                                                                navigate(
                                                                    `/admin/establishments-list?facilityType=${encodeURIComponent(item.name)}`
                                                                )
                                                            }
                                                        >
                                                            <i className="bi bi-building" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-minimal"
                                                            title="تعديل"
                                                            onClick={() => openEdit(item.facilityTypeId)}
                                                        >
                                                            <i className="bi bi-pencil" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-minimal text-danger-hover"
                                                            title="حذف"
                                                            onClick={() => handleDelete(item.facilityTypeId)}
                                                        >
                                                            <i className="bi bi-trash3" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                <FacilityTypeManagementModals
                    modal={modal}
                    facilityTypeId={modalFacilityTypeId}
                    onClose={closeModal}
                    onSaved={onModalSaved}
                />
            </div>
        </div>
    );
}
